
export enum CountryCodes {
    CA = "CA",
    US = "US",
    CO = "CO",
    MX = "MX"
}



// WEBPACK FOOTER //
// ./src/constants/countries.ts